import { useRelatedLinks } from "../../hooks/useRelatedLinks";

function RelatedLinksTab({ event }) {
  const { links, loading } = useRelatedLinks(event);

  if (loading) {
    return <p className="text-gray-500">Loading links...</p>;
  }

  if (links.length === 0) {
    return <p className="text-gray-500 italic">No related links.</p>;
  }

  return (
    <ul className="list-disc pl-6 space-y-2">
      {links.map((link) => (
        <li key={link.id}>
          <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {link.display_name}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default RelatedLinksTab;
